import categoryGenericIcon from '../images/category-icons/category-generic.svg';

export const normalizeCategoryName = value => String(value ?? '')
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('es-CO')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const categoryIcons = Object.freeze({});

export const resolveCategoryIcon = categoryName => (
    categoryIcons[normalizeCategoryName(categoryName)] || categoryGenericIcon
);
